import * as React from 'react';
import { Row, Col, Label, Input } from 'reactstrap';
import { updateTableFact, Afr, getSelectedAfr, getTable, getRow } from '../../redux/AfrSlice';
import { setIsDirty } from '../../redux/MiscSlice';
import { useAppSelector, useAppDispatch } from '../../hooks';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input-field';
import { loadConcept, getAccountId } from '../../redux/ConceptSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';

/* 
------------------------------------------------------------------------------------------------------------------------------------
| Name	                | Type	       | Default       | Description                                                               |
------------------------------------------------------------------------------------------------------------------------------------
| allowDecimals	        | boolean      | true          | Allow decimals                                                            |
| allowNegativeValue	| boolean      | true          | Allow user to enter negative value                                        |
| placeholder	        | string       |               | Placeholder if no value                                                   |
| prefix	            | string       |               | Include a prefix eg. £ or $                                               |
| disabled	            | boolean      |false          | Disabled                                                                  |
| maxLength	            | number       |               | Maximum characters the user can enter                                     |
------------------------------------------------------------------------------------------------------------------------------------
*/

const FactEditor = (props: {
    tableName: string,
    conceptId: string,
    rowCode: string,
    columnCode: string,
    allowDecimals: boolean,
    allowNegativeValue: boolean,
    prefix: string,
    disabled: boolean,
    maxLength: number,
    placeholder: string,
    }) => {

    const dispatch = useAppDispatch();
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const tableId = getTable(currentAfr, props.tableName);
    var initialValue = "";

    if (tableId) {
        var row = getRow(tableId, props.rowCode);
        if (row && row.facts && row.facts.length > 0 ) {
            // Assume a 1-column table for now
            initialValue = row.facts[0].value + "";
        }
    }
    const [factValue, setFactValue] = React.useState<string>(initialValue);


    function handleChange(value: any, name: any) {
        setFactValue(value);
    }

    function handleClick(event: any) {
        dispatch(loadConcept({
            conceptId: props.conceptId,
            taxonomyType: currentAfr ? currentAfr.taxonomyType : TaxonomyTypeEnum.AFR,
            afrYear: currentAfr ? currentAfr.year : 2022
        }));
    }


    function onFactChanged(
        e: React.FocusEvent<HTMLInputElement>,
    ) {
        const value = e.target.value ? factValue : "";

        var newFactParameter = {
            tableId: props.tableName,
            rowId: props.rowCode,
            fundGroup: props.columnCode,
            concept: props.conceptId,
            value: value
        }
       
        dispatch(updateTableFact(newFactParameter));

        // Set the information as dirty
        dispatch(setIsDirty({ IsDirty: true, Page: "" }))
    }

    React.useEffect(function () {

        setFactValue(initialValue);

    }, [initialValue])

    return (
        <React.Fragment>

                    <Row>
                        <Col  className="text-left" onClick={handleClick}>
                            <CurrencyInput
                                name=""
                                value={factValue}
                                placeholder={props.placeholder}
                                allowDecimals={props.allowDecimals}
                                allowNegativeValue={props.allowNegativeValue}
                                prefix={props.prefix}
                                maxLength={props.maxLength}
                                disabled={props.disabled}
                                onValueChange={handleChange}
                                onBlur={(e: any) => onFactChanged(e)}
                                
                            />

                        </Col>
                    </Row>

        </React.Fragment>
    );
}

export default FactEditor;